(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/hooks/use-draw.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/hooks/use-draw.js');
"use strict";


const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const loadDrawByProduct = svs.components.sport.drawsRedux.actions.loadDrawByProduct;
const selectDraw = svs.components.sport.drawsRedux.selectors.selectDraw;
const _React = React,
  useEffect = _React.useEffect;
const useDraw = function (_ref) {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber;
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$skip = _ref2.skip,
    skip = _ref2$skip === void 0 ? false : _ref2$skip,
    _ref2$shouldFetchJack = _ref2.shouldFetchJackpot,
    shouldFetchJackpot = _ref2$shouldFetchJack === void 0 ? false : _ref2$shouldFetchJack;
  const dispatch = useDispatch();
  const draw = useSelector(state => selectDraw(state, productId, drawNumber));
  useEffect(() => {
    if (!productId || !drawNumber || skip) {
      return;
    }
    if (!draw || Object.keys(draw).length === 0) {
      dispatch(loadDrawByProduct({
        drawNumber,
        productId,
        shouldFetchJackpot
      }));
    }
  }, [productId, drawNumber, draw, dispatch, skip, shouldFetchJackpot]);
  return draw;
};
setGlobal('svs.components.sport.drawsRedux.hooks.useDraw', useDraw);

 })(window);